/**
 * 缓存福利卡信息到本地存储
 * @param {Object} cardInfo - 福利卡信息对象
 * @returns {Promise} Promise对象
 */
export function cacheCardInfo(cardInfo) {
    return new Promise((resolve, reject)=> {
        if(cardInfo) {
            localStorage.setItem("cardId", cardInfo.cardId);
            localStorage.setItem("upgradeFlag", cardInfo.upgradeFlag);
            localStorage.setItem("bathId", cardInfo.id);
            // 缓存福利卡点数类型
            localStorage.setItem("cardPointType", cardInfo.cardPointType || '0');
            // 通知底部导航栏更新首页路由
            window.dispatchEvent(new Event('cardChange'));
            resolve();
        }else {
            reject();
        }
    })
}

/**
 * 获取当前使用的福利卡点数类型
 * @returns {String} 卡片点数类型
 */
export function getCurrentCardPointType() {
    return localStorage.getItem("cardPointType") || '0';
}

/**
 * 点数类型与单位映射
 */
const UNIT_MAP = {
  '0': '点',
  '1': '点', // 通兑票，暂时设置为点
  '2': '点',
  '3': '次',
  '4': '金豆'
};

/**
 * 获取当前福利卡类型对应的单位
 */
export function getCurrentPointUnit() {
  const cardPointType = getCurrentCardPointType();
  return UNIT_MAP[cardPointType] || '点';
}

